<template>
  <div>
    <el-row>
      <el-col :span="24" class="text-right"></el-col>
    </el-row>

    <div class="margin-top">
      <el-table :data="feeDetailHisFeeInfo.feeDetails" style="width: 100%">
        <el-table-column prop="feeName" :label="$t('feeDetailHisFee.feeName')" align="center"></el-table-column>
        <el-table-column prop="payerObjName" :label="$t('feeDetailHisFee.payerObjName')"
          align="center"></el-table-column>
        <el-table-column prop="cycles" :label="$t('feeDetailHisFee.cycles')" align="center"></el-table-column>
        <el-table-column :label="$t('feeDetailHisFee.amount')" align="center">
          <template slot-scope="scope">
            {{ scope.row.receivableAmount }}/{{ scope.row.receivedAmount }}<br>
            <div v-if="scope.row.acctAmount > 0">
              {{ $t('feeDetailHisFee.accountDeduction') }}: {{ scope.row.acctAmount }}<br>
            </div>
            <div v-for="(item, index) in scope.row.payFeeDetailDiscountDtoList" :key="index">
              {{ item.discountName }}: {{ Math.abs(item.discountPrice) }}<br>
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('feeDetailHisFee.paymentMethod')" align="center">
          <template slot-scope="scope">
            {{ formatPayMethod(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('feeDetailHisFee.paymentPeriod')" align="center">
          <template slot-scope="scope">
            {{ dateFormat(scope.row.startTime) }}~<br>
            {{ dateFormat(scope.row.endTime) }}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" :label="$t('feeDetailHisFee.paymentTime')" align="center"></el-table-column>
        <el-table-column prop="cashierName" :label="$t('feeDetailHisFee.cashier')" align="center">
          <template slot-scope="scope">{{ scope.row.cashierName || '-' }}</template>
        </el-table-column>
        <el-table-column prop="stateName" :label="$t('feeDetailHisFee.status')" align="center"></el-table-column>
        <el-table-column :label="$t('feeDetailHisFee.remark')" align="center">
          <template slot-scope="scope">
            {{ cleanRemark(scope.row.remark) }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('feeDetailHisFee.operation')" align="center">
          <template slot-scope="scope">
            <el-button v-if="scope.row.state == '1400' || scope.row.state == '1200' || scope.row.state == ''" size="mini"
              @click="_toRefundFee(scope.row)">
              {{ $t('feeDetailHisFee.detail') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-row class="margin-top">
        <el-col :span="12"></el-col>
        <el-col :span="12">
          <el-pagination @current-change="handleCurrentChange" :current-page="pagination.currentPage"
            :page-size="pagination.pageSize" layout="total, prev, pager, next" :total="pagination.total">
          </el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { queryFeeDetail } from '@/api/fee/feeDetailHisFeeApi'
import { getCommunityId } from '@/api/community/communityApi'
import { dateFormat } from '@/utils/dateUtil'

export default {
  name: 'FeeDetailHisFee',
  data() {
    return {
      feeDetailHisFeeInfo: {
        feeDetails: [],
        feeId: ''
      },
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  methods: {
    open(params) {
      this.feeDetailHisFeeInfo.feeId = params.feeId
      this._loadFeeDetailHisFeeData()
    },
    _loadFeeDetailHisFeeData() {
      const params = {
        communityId: getCommunityId(),
        feeId: this.feeDetailHisFeeInfo.feeId,
        page: this.pagination.currentPage,
        row: this.pagination.pageSize
      }

      queryFeeDetail(params).then(res => {
        const feeDetails = res.feeDetails || res.data || []
        this.feeDetailHisFeeInfo.feeDetails = Array.isArray(feeDetails) ? feeDetails : []
        this.pagination.total = Number(res.total || res.records || this.feeDetailHisFeeInfo.feeDetails.length || 0)
      }).catch(error => {
        console.error('Failed to load fee detail history:', error)
      })
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this._loadFeeDetailHisFeeData()
    },
    _toRefundFee(detail) {
      this.$router.push(`/views/fee/propertyFee?feeId=${detail.feeId}`)
    },
    formatPayMethod(row) {
      const acctAmount = parseFloat(row.acctAmount || 0)
      const receivedAmount = parseFloat(row.receivedAmount || 0)
      const primeRateName = row.primeRateName || ''
      if (acctAmount > 0 && receivedAmount > 0) {
        return `${primeRateName || '线上支付'} + 通用账户抵扣`
      }
      if (acctAmount > 0) {
        return '通用账户抵扣'
      }
      return primeRateName || '-'
    },
    cleanRemark(remark) {
      if (remark === null || remark === undefined) {
        return ''
      }
      return String(remark).replace(/^(null|undefined)[，,、\s]*/i, '')
    },
    dateFormat(date) {
      return date ? dateFormat(date) : '-'
    }
  }
}
</script>
